import { render, staticRenderFns } from "./IngredientRow.vue?vue&type=template&id=7a7bb607&"
import script from "./IngredientRow.vue?vue&type=script&lang=js&"
export * from "./IngredientRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports